<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <b v-if="id != null">Edit {{ title }}</b>
      <b v-else>Create {{ title }}</b>
    </span>
    <br/><br/>

    <!-- Code -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Code"
          name="code"
          v-validate="'required'"
          v-model="data.code"
        />
        <span class="text-danger text-sm" v-show="errors.has('code')">
          {{ errors.first('code') }}
        </span>
      </div>
    </div>

    <!-- Name -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Name"
          name="name"
          v-validate="'required'"
          v-model="data.name"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">
          {{ errors.first('name') }}
        </span>
      </div>
    </div>

    <!-- Group -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Group</label>
        <multiselect
          name="Group"
          v-model="data.group.selected"
          :options="data.group.options"
          placeholder="Type to search"
          :max-height="125"
          v-validate="'required'"
        >
          <span slot="noResult">Oops! No data found</span>
          <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
              <span class="option__title">{{ props.option.Name }}</span>
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">{{ props.option.Name }}</span>
            </div>
          </template>
        </multiselect>
        <span class="text-danger text-sm" v-show="errors.has('Group')">
          {{ errors.first("Group") }}
        </span>
      </div>
    </div>

    <!-- Operating Unit -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Operating Unit</label>
        <multiselect
          name="Ou"
          v-model="data.ou.selected"
          :options="data.ou.options"
          placeholder="Type to search"
          :max-height="125"
          v-validate="'required'"
          :multiple="true"
          :allow-empty="true"
          track-by="id"
          label="name"
          @input="handleOuSelection"
        >
          <span slot="noResult">Oops! No data found</span>
          <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
              <span class="option__title">{{ props.option.code }} - {{ props.option.name }}</span>
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">{{ props.option.code }} - {{ props.option.name }}</span>
            </div>
          </template>
        </multiselect>
        <span class="text-danger text-sm" v-show="errors.has('Ou')">
          {{ errors.first("Ou") }}
        </span>
      </div>
    </div>

    <!-- Default Journal -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Default Journal</label>
        <br/>
        <ul class="centerx">
          <li>
            <vs-radio v-model="data.type" vs-value="D">Debit</vs-radio>
          </li>
          <li>
            <vs-radio v-model="data.type" vs-value="C">Kredit</vs-radio>
          </li>
        </ul>
      </div>
    </div>

    <!-- Allow non-default -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Allow non-default</label>
        <vs-switch
          color="dark"
          icon-pack="feather"
          vs-icon-on="icon-check-circle"
          vs-icon-off="icon-slash"
          v-model="data.is_allow"
        >
          <span slot="on">True</span>
          <span slot="off">False</span>
        </vs-switch>
      </div>
    </div>

    <!-- Actions -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="handleSubmit">Submit</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="danger" @click="handleClose">Close</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
    url: String,
    title: String
  },
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        data: {
          id: null,
          name: "",
          code: "",
          type: "D",
          is_allow: true,
          group: {
            options: [],
            selected: null
          },
          ou: {
            options: [],
            selected: null
          },
        },
      };
    },
    handleSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;

        let isValid = true;
        if (!this.data.group.selected) {
          this.errors.add({field: "Group", msg: "The Group field is required"});
          isValid = false;
        }
        if (!this.data.ou.selected || this.data.ou.selected.length === 0) {
          this.errors.add({field: "Ou", msg: "The Operating Unit field is required"});
          isValid = false;
        }

        if (!isValid) return;

        this.$vs.loading();
        this.id ? this.putData() : this.postData();
      });
    },
    paramData() {
      return {
        name: this.data.name,
        code: this.data.code,
        type: this.data.type,
        is_allow: this.data.is_allow,
        chart_of_account_group_id: this.data.group.selected.ID,
        operating_unit: this.data.ou.selected.map((item) => ({
          id: item.id,
          code: item.code,
          name: item.name,
        })),
      };
    },
    postData() {
      this.$http.post(this.url, this.paramData())
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.handleClose();
            this.notifySuccess("Created");
          } else {
            this.notifyError(resp.message);
          }
        }).catch(this.handleError);
    },
    putData() {
      this.$http.put(`${this.url}/${this.id}`, this.paramData())
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.handleClose();
            this.notifySuccess("Updated");
          } else {
            this.notifyError(resp.message);
          }
        }).catch(this.handleError);
    },
    getData() {
      this.$vs.loading();
      this.$http.get(`${this.url}/${this.id}`)
        .then((resp) => {
          if (resp.code === 200) {
            const {coa, coa_ou} = resp.data[0];

            this.data.code = coa.Code;
            this.data.name = coa.Name;
            this.data.is_allow = Boolean(coa.IsAllow);
            this.data.type = coa.Type;

            this.$nextTick(() => {
              this.data.group.selected = this.data.group.options.find(g => g.ID === coa.ChartOfAccountGroupID);

              const selectedOu = coa_ou
                .map(ou => this.data.ou.options.find(o => o.id === ou.OperatingUnitID))
                .filter(Boolean);

              this.data.ou.selected = selectedOu;
            });

          } else {
            this.notifyError(resp.message);
          }
          this.$vs.loading.close();
        }).catch(this.handleError);
    },
    getDataGroup() {
      return this.$http.get("/api/v1/master/chart-of-account-group", {params: {order: "name", sort: "asc"}})
        .then(resp => {
          if (resp.status === "success") this.data.group.options = resp.data.records;
        });
    },
    getDataOu() {
      return this.$http.get("/api/v1/master/operating-units", {params: {order: "name", sort: "asc"}})
        .then(resp => {
          if (resp.status === "success") {
            const allOption = {id: 0, name: "ALL", code: "ALL"};
            this.data.ou.options = [allOption, ...resp.data.records];
          }
        });
    },
    handleOuSelection(selected) {
      const all = selected.find(opt => opt.id === 0);
      this.data.ou.selected = all ? [all] : selected.filter(opt => opt.id !== 0);
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    notifySuccess(action) {
      this.$vs.notify({
        color: "success",
        title: "Success",
        text: `${this.title} ${action}`,
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });
    },
    notifyError(msg) {
      this.$vs.notify({
        color: "danger",
        title: "Error",
        text: msg,
        position: "top-right",
        iconPack: "feather",
        icon: "icon-alert-triangle",
      });
    },
    handleError(err) {
      this.$vs.loading.close();
      console.error(err);
    }
  },
  mounted() {
    Promise.all([this.getDataGroup(), this.getDataOu()])
      .then(() => {
        if (this.id) this.getData();
      });
  },
  watch: {
    id(newVal) {
      if (!newVal) {
        Object.assign(this.$data, this.initialState());
      } else {
        Promise.all([
          this.getDataGroup(),
          this.getDataOu()
        ]).then(() => this.getData());
      }
    },
    'data.group.options'(val) {
      if (this.id && val.length && !this.data.group.selected) {
        this.getData();
      }
    },
    'data.ou.options'(val) {
      if (this.id && val.length && (!this.data.ou.selected || !this.data.ou.selected.length)) {
        this.getData();
      }
    }
  }
};
</script>
